import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFullscreen.tsx
const IconFullscreen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M20 3h2v6h-2V5h-4V3zM4 3h4v2H4v4H2V3zm16 16v-4h2v6h-6v-2zM4 19h4v2H2v-6h2z"
	})]
});
var IconFullscreen_default = forwardRef(IconFullscreen);
//#endregion
export { IconFullscreen_default as default };
